/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
==========================================================================================*/

export default [
  {
    url: "/pages/selfservice-select",
    name: "Sıcak Satış Ekranı",
    slug: "sale",
    icon: "icon-hot-sale-screen",
  },
  {
    name: "Sıcak Satış Kayıtları",
    icon: "icon-hot-sales-reports",
    submenu: [
      {
        url: "/pages/orderLogs",
        name: "Sıcak Satış Detayları",
        slug: "orderLogs",
        icon: "icon-cash-box",
      },
      {
        url: "/pages/totalOrderLogs",
        name: "Toplam Ciro Raporu",
        slug: "orderLogs",
        icon: "icon-discount",
      },
      {
        url: "/pages/expenses",
        name: "Giderlerim",
        slug: "expenses",
        icon: "icon-rich",
      },
      {
        url: "/pages/expenseDefinitions",
        name: "Gider Tipleri",
        slug: "expenseDefinitions",
        icon: "icon-rich",
      },
    ],
  },
  {
    name: "Raporlar",
    url: null,
    icon: "icon-cash-box",
    submenu: [
      {
        url: "/pages/Reports/Inventory-Report",
        name: "Envanter Raporu",
        slug: "inventory-report",
        icon: "icon-inventory",
      },
      {
        url: "/pages/reports/branch-report",
        name: "Şube Ciro Raporu",
        slug: "branch-report",
        icon: "icon-inventory",
      },
      {
        url: "/pages/reports/category-report",
        name: "Kategori Ciro Raporu",
        slug: "category-report",
        icon: "icon-inventory",
      },
      {
        url: "/pages/reports/product-report",
        name: "Ürün Ciro Raporu",
        slug: "product-report",
        icon: "icon-inventory",
      },
      {
        url: "/pages/reports/cari-report",
        name: "Cari Raporu",
        slug: "cari-report",
        icon: "icon-inventory",
      },
      {
        url: "/pages/reports/BranchComparativeReport",
        name: "Şube Karşılaştırma",
        forCenter: true,
        slug: "branch-comparative-report",
        icon: "icon-inventory",
      },
      {
        url: "/pages/reports/giro-by-time",
        name: "Zamana Göre Ciro Raporu",
        slug: "report-by-time",
        icon: "icon-inventory",
      },
      {
        url: "/pages/reports/giro-by-date",
        name: "Tarihe Göre Ciro Raporu",
        slug: "report-by-date",
        icon: "icon-inventory",
      },
      {
        url: "/pages/reports/raw-material-consumption",
        name: "Hammadde Tüketim Raporu",
        slug: "raw-material-consumption",
        icon: "icon-inventory",
      },
      {
        url: "/pages/reports/day-report",
        name: "Gün Raporları",
        slug: "wallet-transaction",
        icon: "icon-inventory",
      },
      {
        url: "/pages/reports/staff-action-report",
        name: "Personel İşlem Raporu",
        slug: "staff-action-report",
        icon: "icon-inventory",
      },
      {
        url: "/pages/reports/z-report",
        name: "Z Raporu",
        slug: "z-report",
        icon: "icon-inventory",
      },
    ],
  },
  {
    name: "Stoklar",
    url: null,
    icon: "icon-barn",
    submenu: [
      {
        url: "/pages/Stocks",
        name: "Stok Listesi",
        icon: "icon-checklist2",
        slug: "stockList",
      },
      {
        url: "/pages/Bills",
        name: "Faturalarım",
        icon: "icon-bills",
        slug: "billList",
      },
      {
        url: "/pages/MonthlyStockTransfer",
        name: "Ay Sonu Stok Sayımı ve Devir",
        icon: "icon-transfer-coffee",
        slug: "monthlyStockTransfer",
      },
    ],
  },
  {
    url: "/pages/StockOrder",
    name: "Siparişlerim",
    icon: "icon-checklist2",
    slug: "stockOrderList",
  },
  {
    url: "/pages/Targets",
    name: "Hedefler",
    slug: "targers",
    icon: "icon-units",
  },
  {
    name: "Ürünler",
    icon: "icon-products",
    submenu: [
      {
        url: "/pages/Products",
        name: "Ürün Listesi",
        icon: "icon-product-list",
        slug: "productList",
      },
      {
        url: "/pages/ProductCategories",
        name: "Ürün Kategori Listesi",
        icon: "icon-role",
        slug: "productCategoryList",
      },
      {
        url: "/pages/RawMaterials",
        name: "Hammaddeler",
        icon: "icon-raw-materials",
        slug: "rawMaterialList",
      },
      {
        url: "/pages/RawMaterialCategories",
        name: "Hammadde Kategorileri",
        icon: "icon-raw-materials",
        slug: "rawMaterialCategoryList",
      },
      {
        url: "/pages/Recipes",
        name: "Reçeteler",
        icon: "icon-recipe",
        slug: "recipeList",
      },
      {
        url: "/pages/HalfMadeProducts",
        name: "Yarı Mamüller",
        icon: "icon-semi-products",
        slug: "halfMadeProductList",
      },
      {
        url: "/pages/ProductExtras",
        name: "Ekstralar",
        icon: "icon-coffee-preparation",
        slug: "productExtraList",
      },
      {
        url: "/pages/ProductSizes",
        name: "Boylar",
        icon: "icon-coffee-preparation",
        slug: "productSizeList",
      },
    ],
  },
  {
    name: "Şube & Kullanıcı",
    icon: "icon-branches",
    submenu: [
      {
        url: "/pages/Branchs",
        name: "Şube Listesi",
        icon: "icon-branches",
        slug: "branchList",
      },
      {
        url: "/pages/Users",
        name: "Kullanıcı Listesi",
        slug: "users",
        icon: "icon-pick-users",
      },
      {
        url: "/pages/roles",
        name: "Roller",
        slug: "roles",
        icon: "icon-pick-users",
        onlyAdmin: true,
      },
    ]
  },
  {
    name: "İndirim & Zaiyat",
    icon: "icon-pick-box",
    submenu: [
      {
        url: "/pages/discount",
        name: "İndirimler",
        slug: "discounts",
        icon: "icon-rich",
      },
      {
        url: "/pages/discountReason",
        name: "İndirim Sebepleri",
        slug: "discount-reason",
        icon: "icon-rich",
      },
      {
        url: "/pages/losses",
        name: "Zayiatlar",
        slug: "losses",
        icon: "icon-logistic",
      },
      {
        url: "/pages/lossReasons",
        name: "Zayiat Sebepleri",
        slug: "lossReasons",
        icon: "icon-delivery-man",
      },
    ]
  },
  {
    url: "/pages/Units",
    name: "Birim Listesi",
    slug: "units",
    icon: "icon-units",
  },
  {
    url: "/pages/PriceLists",
    name: "Fiyat Listeleri",
    slug: "priceLists",
    forTenantCenter: true,
    icon: "icon-card",
  },
  {
    url: "/pages/userwant",
    name: "BM İletişim Sistemi",
    slug: "user-wants",
    forCenter: true,
    icon: "icon-card",
  },
  {
    name: "Otomasyon & POS",
    icon: "icon-pick-box",
    submenu: [
      {
        url: "/pages/pos-settings",
        name: "Pos Ayarları",
        slug: "posSettings",
        icon: "icon-card",
      },
      {
        url: "/pages/all-pos-settings",
        name: "Toplu Pos Ayarları",
        slug: "allposSettings",
        icon: "icon-card",
        onlyAdmin: true,
      },
      {
        url: "/pages/payment-methods",
        name: "Ödeme Tipleri",
        slug: "paymmentMethods",
        icon: "icon-card",
      },
      {
        url: "/pages/Suppliers",
        name: "Tedarikçi Listesi",
        slug: "suppliers",
        icon: "icon-logistic",
      },
    ]
  },
  {
    name: "Ayarlar",
    icon: "icon-pick-box",
    submenu: [
      {
        url: "/pages/kitchens",
        name: "Mutfaklar",
        slug: "kitchens",
        icon: "icon-card",
      },
      {
        url: "/pages/printer-settings",
        name: "Yazıcı Ayarları",
        slug: "printerSettings",
        icon: "icon-card",
      },
      {
        url: "/pages/kuver-settings",
        name: "Kuver Ayarları",
        slug: "kuverSettings",
        icon: "icon-card",
      },
      {
        url: "/pages/cari",
        name: "Cari Hesaplar",
        slug: "cari",
        icon: "UserIcon",
      },
      {
        url: "/pages/qr-menu",
        name: "QR Menü",
        slug: "qr-menu",
        icon: "icon-card",
      },
      {
        url: "/pages/blackLists",
        name: "Kara Liste",
        slug: "blackList",
        icon: "icon-pick-users",
        forCenter: true,
      },
      {
        url: "/pages/app-settings",
        name: "Panel Ayarları",
        slug: "appSettgins",
        icon: "icon-card",
      }
    ]
  }
];
